<template>
	<UITopHeading>Verlaufen?</UITopHeading>
	<div class="container flex flex-col text-center">
		<h2>Diese Seite existiert nicht.</h2>
		<p class="mb-4">
			Hast du dich auf dem Festivalgelände verlaufen? Hier gehts zurück zur
			Startseite:
		</p>
		<NuxtLink to="/">Bring mich zurück</NuxtLink>
	</div>
</template>
